import type { PropsWithChildren } from "react";

export const Loading: React.FC<PropsWithChildren> = ({ children }) => {
	return (
		<div className="flex justify-center items-center">
			{children || "Carregando"}
			<div
				className="h-3 w-3 border-2 border-x-slate-200 border-y-slate-200
        border-t-slate-400 rounded-full ml-1 animate-spin"
			/>
		</div>
	);
};
